export default __webpack_public_path__ + "single_dose_icon.png";